import {ChangeEvent, MouseEvent, useCallback, useEffect, useState} from "react";
import {SchemaItem} from "../listan-backend-api";
import AddItem from "./AddItem";
import {CheckedItemPosition, ListOptions} from "../ClientSidetypes";
import { Temporal } from 'temporal-polyfill';

type SchemaItemWithGroupDetails = {
    itemData: SchemaItem,
    groupNumber: number
}

// We put it here so that safari only loads the sound once
let fetchedArrayBuffer: ArrayBuffer

fetch("./click-345983-short.mp3")
    .then((response) => response.arrayBuffer())
    .then(arrayBuffer => {fetchedArrayBuffer = arrayBuffer;});


const map = new Map<string, number>();

// Frukt och grönt
map.set("Banan".toLowerCase(), 1);
map.set("Päron".toLowerCase(), 1);
map.set("Blåbär".toLowerCase(), 1);
map.set("Dill".toLowerCase(), 1);
map.set("Vitlök".toLowerCase(), 1);
map.set("vitlöksklyftor".toLowerCase(), 1);
map.set("Persilja".toLowerCase(), 1);
map.set("Druvor".toLowerCase(), 1);
map.set("Vitdruvor".toLowerCase(), 1);
map.set("Rotselleri".toLowerCase(), 1);
map.set("Lök".toLowerCase(), 1);
map.set("Vitlök".toLowerCase(), 1);
map.set("Isbergssallad".toLowerCase(), 1);
map.set("Rödlök".toLowerCase(), 1);
map.set("Salad".toLowerCase(), 1);
map.set("hjärtsalladshuvuden".toLowerCase(), 1);
map.set("hjärtsalladshuvud".toLowerCase(), 1);
map.set("Sallad".toLowerCase(), 1);
map.set("Potatis".toLowerCase(), 1);
map.set("Gurka".toLowerCase(), 1);
map.set("Tomat".toLowerCase(), 1);
map.set("Röd chili".toLowerCase(), 1);
map.set("Röd paprika".toLowerCase(), 1);
map.set("Grön paprika".toLowerCase(), 1);
map.set("Gul paprika".toLowerCase(), 1);
map.set("Paprika".toLowerCase(), 1);
map.set("Citron".toLowerCase(), 1);
map.set("Lime".toLowerCase(), 1);
map.set("Tomater".toLowerCase(), 1);
map.set("Spetspaprika".toLowerCase(), 1);
map.set("Frukt".toLowerCase(), 1);
map.set("Jordgubbar".toLowerCase(), 1);
map.set("Morötter".toLowerCase(), 1);
map.set("Morot".toLowerCase(), 1);
map.set("Celeri".toLowerCase(), 1);
map.set("Melon".toLowerCase(), 1);
map.set("Basilika".toLowerCase(), 1);
map.set("Dill".toLowerCase(), 1);
map.set("Koriander".toLowerCase(), 1);
map.set("Mynta".toLowerCase(), 1);
map.set("Gräslök".toLowerCase(), 1);
map.set("Citronmelis".toLowerCase(), 1);
map.set("jalapeno".toLowerCase(), 1);
map.set("Hallon".toLowerCase(), 1);
map.set("Potatisar".toLowerCase(), 1);
map.set("Rucola".toLowerCase(), 1);
map.set("zucchini".toLowerCase(), 1);
map.set("körsbärstomater".toLowerCase(), 1);
map.set("Smörgåskrasse".toLowerCase(), 1);
map.set("Brokoli".toLowerCase(), 1);
map.set("Broccoli".toLowerCase(), 1);
map.set("Haricoverts".toLowerCase(), 1);
map.set("Hericoverts".toLowerCase(), 1);
map.set("mandariner".toLowerCase(), 1);
map.set("mandarin".toLowerCase(), 1);

map.set("Coriander".toLowerCase(), 1);
map.set("Onion".toLowerCase(), 1);
map.set("Garlic".toLowerCase(), 1);
map.set("Ginger".toLowerCase(), 1);
map.set("Chilli".toLowerCase(), 1);
map.set("Tomatoes".toLowerCase(), 1);

map.set("Ägg".toLowerCase(), 2);
map.set("Gräddfil".toLowerCase(), 2);
map.set("Färskost".toLowerCase(), 2);
map.set("västerbottensost".toLowerCase(), 2);
map.set("Parmesan".toLowerCase(), 2);
map.set("Mjölk".toLowerCase(), 2);
map.set("halomi".toLowerCase(), 2);
map.set("smördeg".toLowerCase(), 2);
map.set("Grädde".toLowerCase(), 2);
map.set("Yoghurt".toLowerCase(), 2);
map.set("Cream frech".toLowerCase(), 2);
map.set("Smör".toLowerCase(), 2);
map.set("Bregott".toLowerCase(), 2);
map.set("Jäst".toLowerCase(), 2);
map.set("Ost".toLowerCase(), 2);
map.set("Grädde".toLowerCase(), 2);
map.set("Liten ost".toLowerCase(), 2);
map.set("Riben ost".toLowerCase(), 2);
map.set("Prästost".toLowerCase(), 2);
map.set("Gräddost".toLowerCase(), 2);
map.set("Brie".toLowerCase(), 2);
map.set("Skinka".toLowerCase(), 2);
map.set("Chorizo".toLowerCase(), 2);
map.set("Salami".toLowerCase(), 2);
map.set("Korv".toLowerCase(), 2);
map.set("Bacon".toLowerCase(), 2);
map.set("Löjrom".toLowerCase(), 2);
map.set("Brillat savarin".toLowerCase(), 2);
map.set("Délice de Bourgogne".toLowerCase(), 2);
map.set("Delice de Bourgogne".toLowerCase(), 2);
map.set("Blå kastelo".toLowerCase(), 2);
map.set("crème fraiche".toLowerCase(), 2);
map.set("crème fraiche".toLowerCase(), 2);
map.set("fraiche".toLowerCase(), 2);

map.set("Butter".toLowerCase(), 2);

map.set("Bröd".toLowerCase(), 3);
map.set("Korvbröd".toLowerCase(), 3);
map.set("digestivekex".toLowerCase(), 3);
map.set("Nötter".toLowerCase(), 3);
map.set("Lingonsylt".toLowerCase(), 3);
map.set("Sylt".toLowerCase(), 3);
map.set("dijonsenap".toLowerCase(), 3);
map.set("Olivolja".toLowerCase(), 3);
map.set("jungfruolivolja".toLowerCase(), 3);
map.set("vitvinsvinäger".toLowerCase(), 3);
map.set("Olja".toLowerCase(), 3);
map.set("Fisksås".toLowerCase(), 3);
map.set("Flingor".toLowerCase(), 3);
map.set("Muskotnöt".toLowerCase(), 3);
map.set("Salladskryda".toLowerCase(), 3);
map.set("Lasangeplattor".toLowerCase(), 3);
map.set("Makaroner".toLowerCase(), 3);
map.set("Spaghetti".toLowerCase(), 3);
map.set("Musli".toLowerCase(), 3);
map.set("Citronsaft".toLowerCase(), 3);
map.set("Rosmarin".toLowerCase(), 3);
map.set("Kräm".toLowerCase(), 3);
map.set("Hårdbröd".toLowerCase(), 3);
map.set("Kaffe".toLowerCase(), 3);
map.set("Vittbröd".toLowerCase(), 3);
map.set("Kex".toLowerCase(), 3);
map.set("Spageti".toLowerCase(), 3);
map.set("glasnudlar".toLowerCase(), 3);
map.set("Ris".toLowerCase(), 3);
map.set("Tomatpure".toLowerCase(), 3);
map.set("Tomatpuré".toLowerCase(), 3);
map.set("Kakor".toLowerCase(), 3);
map.set("Kakao".toLowerCase(), 3);
map.set("Mjöl".toLowerCase(), 3);
map.set("Ströbröd".toLowerCase(), 3);
map.set("Vetemjöl".toLowerCase(), 3);
map.set("Dinkelmjöl".toLowerCase(), 3);
map.set("Grahamsmjöl".toLowerCase(), 3);
map.set("Strösocker".toLowerCase(), 3);
map.set("Rörsocker".toLowerCase(), 3);
map.set("Sesamfrön".toLowerCase(), 3);
map.set("Durumvete".toLowerCase(), 3);
map.set("Chips".toLowerCase(), 3);
map.set("Toapapper".toLowerCase(), 3);
map.set("Toapaper".toLowerCase(), 3);
map.set("Popcorn".toLowerCase(), 3);
map.set("Dipsås".toLowerCase(), 3);
map.set("Salt".toLowerCase(), 3);
map.set("Flingsalt".toLowerCase(), 3);
map.set("Majonnäs".toLowerCase(), 3);
map.set("Vaniljsocker".toLowerCase(), 3);
map.set("Rapsolja".toLowerCase(), 3);
map.set("rödvinsvinäger".toLowerCase(), 3);
map.set("risvinäger".toLowerCase(), 3);
map.set("Matlagningsvin".toLowerCase(), 3);
map.set("majsstärkelse".toLowerCase(), 3);
map.set("svartpeppar".toLowerCase(), 3);
map.set("lagerblad".toLowerCase(), 3);
map.set("spiskummin".toLowerCase(), 3);
map.set("oregano".toLowerCase(), 3);
map.set("chilipulver".toLowerCase(), 3);
map.set("timjan".toLowerCase(), 3);

map.set("Turmeric".toLowerCase(), 3);
map.set("Cumin seeds".toLowerCase(), 3);
map.set("Bay leaves".toLowerCase(), 3);
map.set("Green cardamom".toLowerCase(), 3);
map.set("Garam masala".toLowerCase(), 3);
map.set("Oil".toLowerCase(), 3);
map.set("Soja".toLowerCase(), 3);
map.set("köttbuljongtärning".toLowerCase(), 3);
map.set("buljongtärning".toLowerCase(), 3);
map.set("Tomatpure".toLowerCase(), 3);

map.set("Köttfärs".toLowerCase(), 4);
map.set("Blandfärs".toLowerCase(), 4);
map.set("Räkor".toLowerCase(), 4);
map.set("Lamb".toLowerCase(), 4);
map.set("Köttbullar".toLowerCase(), 4);

map.set("Glass".toLowerCase(), 5);
map.set("Kräftor".toLowerCase(), 5);
map.set("Räckor".toLowerCase(), 5);

map.set("Juice".toLowerCase(), 6);
map.set("Öl".toLowerCase(), 6);
map.set("Vatten".toLowerCase(), 6);
map.set("Folköl".toLowerCase(), 6);
map.set("Lättöl".toLowerCase(), 6);
map.set("Läsk".toLowerCase(), 6);
map.set("Saft".toLowerCase(), 6);
map.set("Cola".toLowerCase(), 6);
map.set("Cider".toLowerCase(), 6);
map.set("Fanta".toLowerCase(), 6);
map.set("Sprite".toLowerCase(), 6);

map.set("Badrumstvål".toLowerCase(), 7);
map.set("Grillkol".toLowerCase(), 7);
map.set("Tvål".toLowerCase(), 7);
map.set("Tandkräm".toLowerCase(), 7);

const mapToSortable = (itemsToMap: SchemaItem[]) : SchemaItemWithGroupDetails[]  => {
    return itemsToMap.map((item) => {
        /*
            TODO, write tests for this
         */

        // Perfect 1 to 1 match
        if (map.has(item.text.toLowerCase())) {
            return {itemData: item, groupNumber: map.get(item.text.toLowerCase())};
        }

        // Partial match where one of the words is in the map
        if (item.text.indexOf(" ") !== -1) {
            for (let word of item.text.toLowerCase().replace("-", "").replace(",", "").split(" ")) {
                if (map.has(word)) {
                    return {itemData: item, groupNumber: map.get(word)};
                }
            }
        }

        /*
            Partial match where one of the words in the map is part of the text

            This should match things like "Tvål" and "Tvålar"
         */
        var itemTextWithOnlyLetters = item.text.toLowerCase().replaceAll(/[0-9/]/g, "")

        var itemTextWithOnlyLettersAndWithoutUnits = itemTextWithOnlyLetters
          .replaceAll(/ (msk|tsk|st|g|liten|kruka) /g, "")

        for (let key of map.keys()) {
            if (
              itemTextWithOnlyLettersAndWithoutUnits.indexOf(key.toLowerCase()) !== -1
              && key.length >= itemTextWithOnlyLettersAndWithoutUnits.length * 0.6 // The key must be at least 60% of the charters
            ) {
                console.log(itemTextWithOnlyLettersAndWithoutUnits)
                return {itemData: item, groupNumber: map.get(key)};
            }
        }

        return {itemData: item, groupNumber: 999};
    }) as SchemaItemWithGroupDetails[];
}

export default function List(
    {
        items,
        setCheckStatus,
        removeItem,
        updateItemText,
        listOptions,
        disabled,
    } : {
        items: SchemaItem[],
        setCheckStatus: (uuid: string, checked: boolean) => void,
        removeItem: (uuid: string) => void,
        updateItemText: (uuid: string, text: string) => void,
        listOptions: ListOptions
        disabled: boolean
    }
) {

    const groupColors = [
        "#95E082", // Something green
        "#57B9FF", // Light blue
        "#CC8A6E", // Nice brown
        "#F71941", // Plesent red
        "#e5f1ff", // Very light blue
        "#fcb42f", // ??
        "#ff67d2" // ???
    ];



    const [itemIdToEdit, setItemIdToEdit] = useState("");
    const [itemIdToEditLastChanged, setItemIdToEditLastChanged] = useState(0);
    const [copyOfitems, setCopyOfItems] = useState(mapToSortable(items));

    const sortByTimeStamp = (a : SchemaItemWithGroupDetails, b : SchemaItemWithGroupDetails) => {
        return Temporal.PlainDateTime.compare(
          Temporal.PlainDateTime.from(a.itemData.addedAt),
          Temporal.PlainDateTime.from(b.itemData.addedAt)
        )
    }

    const sortByGroup = (a: SchemaItemWithGroupDetails, b: SchemaItemWithGroupDetails) => {
        return a.groupNumber - b.groupNumber;
    };

    useEffect(() => {
        let toSort = mapToSortable(items);

        toSort.sort(sortByTimeStamp);

        if (listOptions.groupByType) {
            toSort.sort(sortByGroup);
        }

        if (listOptions.checkedItemPosition === CheckedItemPosition.CheckedItemsList) {
            toSort = toSort.filter(a => !a.itemData.checked);
        }

        if (listOptions.checkedItemPosition === CheckedItemPosition.EndOfList) {
            toSort.sort((a, b) => {
                if (a.itemData.checked === b.itemData.checked) {
                    return 0;
                } else if (a.itemData.checked) {
                    return 1;
                } else {
                    return -1;
                }
            });
        }

        setCopyOfItems(toSort);

    }, [listOptions, items]);

    const updateCheckStatus = (event : ChangeEvent<HTMLInputElement>) => {
        setCheckStatus(event.target.name, event.target.checked)
    };

    const removeClick = (event: MouseEvent<HTMLButtonElement> ) => {
        removeItem(event?.currentTarget?.name);
    };

    const editClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
        if (event?.currentTarget?.name) {
            const nameToChangeTo = event.currentTarget.name;

            // We do it if it was more than 100ms ago
            if (itemIdToEditLastChanged + 100 < Date.now()) {
                setItemIdToEdit((currentValue) => {
                    if (nameToChangeTo === currentValue) {
                        return "";
                    } else {
                        return nameToChangeTo;
                    }
                });
            }
        }
    }, [itemIdToEditLastChanged])

    const updateItem = (newValue: string) => {
        updateItemText(itemIdToEdit, newValue);
        setItemIdToEdit("");
        setItemIdToEditLastChanged(Date.now());
    };

    const play = () =>{
        if (listOptions.playSoundWhenCheckedAndUncheked) {
            if (fetchedArrayBuffer) {
                // TODO, It would be nice to reuse the context and audio buffer
                const audioContext = new AudioContext();
                audioContext.decodeAudioData(structuredClone(fetchedArrayBuffer)).then((audioBuffer) => {
                    const source = audioContext.createBufferSource();
                    source.buffer = audioBuffer;
                    source.connect(audioContext.destination);
                    source.start();

                    return source;
                });
            }
        }
    }

    return (
        <section id={"items-list"} className={ listOptions.checkedItemsSection ? "with-checked-items-section" : ""}>
            {listOptions.checkedItemPosition === CheckedItemPosition.CheckedItemsList ? <h2>Att handla</h2> : <></>}
            <ul id={"theList"} className={disabled ? "disabled" : ""}>
                {
                    copyOfitems.map((item) => {
                        return ( item.itemData.removed ? "" :
                            <li key={item.itemData.id} className={item.itemData.checked ? "checked" : ""} style={listOptions.groupByType ? ({backgroundColor: groupColors[item.groupNumber - 1] || ""}) : {}}>
                                <input disabled={disabled} type={"checkbox"} checked={item.itemData.checked} id={item.itemData.id + "_label"} name={item.itemData.id} onChange={updateCheckStatus} onClick={play}/>
                                <label htmlFor={item.itemData.id + "_label"} onClick={play}>
                                    {
                                        item.itemData.id === itemIdToEdit ? <AddItem disabled={disabled} forceFocus={true} addToList={updateItem} startingText={item.itemData.text} /> : item.itemData.text
                                    }
                                </label>
                                <menu>
                                    <button  disabled={disabled} className={"edit"} name={item.itemData.id} onClick={editClick}>Ändra</button>
                                    <button  disabled={disabled} className={"remove"} name={item.itemData.id} onClick={removeClick}>Ta bort</button>
                                </menu>
                            </li>
                        );
                    })
                }
            </ul>
        </section>
    );
}